import React, {useEffect, useState } from "react";


import {
  Card,
  CardBody,
  Col,
  Row,
  FormGroup,
  Table,
  Label,
  Collapse,
  Input,
  Modal, ModalBody, ModalFooter, ModalHeader, Button
} from "reactstrap";
import Select from 'react-select';
import "bootstrap";
import { DB_FORMAT,
	api,
	LOCAL_STORAGE_USER,
	exportExcel,
	getLocaleFixedValue,
	isActionPermitted,
	SELECTION, STATUS,
	USER_TYPES,
	INCOME_EXPNSE_REPORT_START_DATE,
	BACK_SOCKET_URL
} from "../../util";
import { getPayrollReportRequest } from "../../redux/report/actions";
import { getIncomeExpenseReportRequest } from "../../redux/report/actions";
import { getPeriodsRequest } from "../../redux/report/actions";
import DataTable from "../../components/common/DataTable";

import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { getSaloonsRequest } from "../../redux/saloons/actions";
import PageHeader from "../../components/common/PageHeader";
import { getEmployeesRequest } from "../../redux/employees/actions";
import NoDataFound from "../../components/common/NoDataFound";
import Loading from "../../components/common/Loading";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";

const IncomeExpenseSummary = () => {
	const uploadFolderUrl = BACK_SOCKET_URL + '/uploads';
    const dispatch = useDispatch();
    const [periodsOptions, setPeriodsOptions] = useState({});
    const [periodsDetails, setPeriodsDetails] = useState([]);
    const { permissions , role } = useSelector((state) => state.user);
    const { saloons } = useSelector((state) => state.saloons);
    const { reports , count , loading } = useSelector((state) => state.reports);
    const [paginationConfig, setPaginationConfig] = useState({
        page: 1,
        limit: 10,
        filter : {
        	periodId : "",
            location : ""
        }
    });
    
    useEffect(() => {
    	  Fancybox.bind('[data-fancybox="gallery"]', {
    	    // Optional: customize options here
    	  });

    	  return () => {
    	    // Clean up to avoid memory leaks on unmount
    	    Fancybox.destroy();
    	  };
    	}, []);
    
    
    useEffect(() => {
  	  var periodSelection = [];
  	  periodSelection.push(defaultSelectOption)
  	  periodsDetails.map( (_, index) => (
  			periodSelection.push({ "value": _.id, "label": formatDate(new Date(_.startDate)) + " --- " + formatDate(new Date(_.endDate)) })
  	  ))
  	  setPeriodsOptions(periodSelection);
    }, [periodsDetails]);
    const [isLoading, setIsLoading] = useState(false);
    const defaultSelectOption = { 'label' : 'Select' , 'value' : '' };
    useEffect(() => {
        if (isActionPermitted("payroll-report", "read", permissions)) {
            setDataFound(false);
            if(role == USER_TYPES.SUPER_ADMIN) {
                dispatch(getSaloonsRequest());
            }
            dispatch(getPeriodsRequest(paginationConfig));
        }
    } , [paginationConfig]);
    
    const [dataFound , setDataFound] = useState(false);
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const formatDate = (date, displayDayName = false) => {
        const day = date.getDate();
        const suffix =
          day % 10 === 1 && day !== 11
            ? 'st'
            : day % 10 === 2 && day !== 12
            ? 'nd'
            : day % 10 === 3 && day !== 13
            ? 'rd'
            : 'th';
        
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();
        if (displayDayName === true) {
        	const dayName = days[date.getDay()];
        	return `${day}${suffix} ${month} ${year} (${dayName})`;
        }
        return `${day}${suffix} ${month} ${year}`;
      };
      const cleanOrdinal = (str) => str.replace(/(\d+)(st|nd|rd|th)/, '$1');
      const [accountOptions, setAccountOptions] = useState({});
      const displayPeriodIndo = (periodId) => {
    	  console.log("periodId", periodId);
      }
      const [openIndex, setOpenIndex] = useState(null);
      const [dailyData, setDailyData] = useState({});
      const [loadingIndex, setLoadingIndex] = useState(null);
      const [showExpenseInfoModal, setShowExpenseInfoModal] = useState(false);
      const [expensePopupDetails, setExpensePopupDetails] = useState([]);
      
      const fetchDetails = async (periodId, index) => {
        try {
          setLoadingIndex(index);
          setOpenIndex(index);
          const periodInfoResponse = await api.post('/reports/period-info' , {'period_id' : periodId });
          setDailyData((prev) => ({
            ...prev,
            [periodId]: periodInfoResponse.data.data.list,
          }));
          setLoadingIndex(null);
        } catch (error) {
          console.error("Error fetching data:", error);
          setLoadingIndex(null);
        }
      };
      
      const getExpenseDetails = async (periodId, periodDate = null) => {
          try {
            const expenseInfoResponse = await api.post('/reports/expense-info' , {'period_id' : periodId, 'period_date' : periodDate  });
            setExpensePopupDetails(expenseInfoResponse.data.data.list);
          } catch (error) {
            console.error("Error fetching data:", error);
            
          }
        };

      //const  = (value) => `$${value}`;
      
      const [expenseDate, setExpenseDate] = useState(null);
    return (
        <React.Fragment>
            <PageHeader title="Income Expense Summary" shouldShowAddBtn={false} onAddBtnClick={() => exportExcel('/reports/payrollReport' , paginationConfig)} addBtnText="Export Excel" />
            <Card>
                <CardBody>
                    <Row className="gy-3 gx-3">
                    {role === USER_TYPES.SUPER_ADMIN && (
                            <Col xl={3} md={3} sm={12} xs={12}>
                                <Label>Location</Label>
                                <Input caret type="select" name="location" value={paginationConfig.filter.location}
                                    onChange={(e) => {
                                    	const x = paginationConfig;
                                        x.filter.location = e.target.value;
                                        setPaginationConfig({ ...x });
                                    }}
                                    >
                                    <option value={""}>All Location</option>
                                    {saloons.map((_, index) => (
                                    <option key={_.id} value={_.Saloon.id}>
                                        {_.Saloon.name}{_.Saloon.location && _.Saloon.location != null && (<> - {_.Saloon.location}</>)}
                                    </option>
                                    ))}
                                </Input>
                            </Col>
                        )}
                    </Row>
                </CardBody>
            </Card>
            {!loading ? (
                <>
                <div className="container-fluid mt-5">
                <Card>
                  <CardBody>
                    <Table  hover responsive className="mb-0">
                      <thead className="table-secondary table-secondary-custom">
                        <tr>
                          <th>Period</th>
                          <th>Income</th>
                          <th>Expense</th>
                          <th>Difference</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reports.map((report, index) => {
                          const difference = report.income - report.expense;
                          const isOpen = openIndex === index;
                          const isLoading = loadingIndex === index;

                          return (
                            <React.Fragment key={report.id}>
                              <tr
                                
                                className="fw-semibold-custom single-period-row"
                              >
                                <td className="period-spacing" onClick={() => {
                                    if (!isOpen) {
                                        fetchDetails(report.id, index);
                                      } else {
                                        setOpenIndex(null); // collapse if open
                                      }
                                    }}
                                    style={{ cursor: "pointer" }} >
                                  {formatDate(new Date(report.startDate))} To {formatDate(new Date(report.endDate))}
                                </td>
                                <td className="text-success">{(getLocaleFixedValue(report.income))}</td>
                                <td className="text-danger" 
                                	onClick={() => {
                              		  if (report.expense > 0) {
                              		    setShowExpenseInfoModal(true);
                              		    getExpenseDetails(report.id);
                              		  }
                              		}}
                                >{(getLocaleFixedValue(report.expense))}</td>
                                <td className={difference >= 0 ? "text-success" : "text-danger"}>
                                  {(difference)}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4" className="p-0 border-0">
                                  <Collapse isOpen={isOpen}>
                                    <div className="p-3 bg-light">
                                      {isLoading ? (
                                        <div className="text-center py-4">
                                           Loading details...
                                        </div>
                                      ) : (
                                        <Table bordered size="md" className="mb-0">
                                          <thead className="table-light">
                                            <tr>
                                              <th>Date</th>
                                              <th className="text-success">Income</th>
                                              <th className="text-danger">Expense</th>
                                              <th>Difference</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {dailyData[report.id]?.map((entry, i) => {
                                              const diff = ( parseFloat(entry.income) > 0 ? entry.income : 0 ) - ( parseFloat(entry.expense) > 0 ? entry.expense : 0 );
                                              return (
                                                <tr key={i}>
                                                  <td>{formatDate(new Date(entry.date), true)}</td>
                                                  <td className="text-success">
                                                    {entry.income > 0 ? (getLocaleFixedValue(entry.income)) : " "}
                                                  </td>
                                                  <td className="text-danger" 
                                                	  onClick={() => {
                                                		  if (entry.expense > 0) {
                                                		    setShowExpenseInfoModal(true);
                                                		    getExpenseDetails(report.id, entry.date);
                                                		  }
                                                		}}
                                                  >
                                                    {entry.expense > 0 ? (getLocaleFixedValue(entry.expense)) : ""}
                                                  </td>
                                                  <td
                                                    className={
                                                      diff >= 0 ? "text-success" : "text-danger"
                                                    }
                                                  >
                                                    {diff !== 0 ? (getLocaleFixedValue(diff)) : " "}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </Table>
                                      )}
                                    </div>
                                  </Collapse>
                                </td>
                              </tr>
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </div>
            </>
          ) : (
                <Loading />
          )}
            
            {showExpenseInfoModal && (
                    <Modal size="lg" isOpen={showExpenseInfoModal} centered>
                      <ModalHeader>Expense Info</ModalHeader>
                      <ModalBody>
                        <Table hover responsive className="no-wrap mt-3 align-middle" >
                        	<thead>
                        		<tr>
                        			<td style={{'font-weight' : 'bold'}}>Sr No</td>
                        			<td style={{'font-weight' : 'bold'}}>Saloon</td>
                        			<td style={{'font-weight' : 'bold'}}>Purpose</td>
                        			<td style={{'font-weight' : 'bold'}}>Date</td>
                        			<td style={{'font-weight' : 'bold'}}>Amount</td>
                        		</tr>
                        	</thead>
                        	<tbody>
                        	 {(() => {
                        	  var totalExpense = 0.00; 
                        	  const tableColumns = [];
                              expensePopupDetails?.length > 0 && 
                        			expensePopupDetails.map((expensePopupDetail, index) => (
                                        <>
                                        {(() => {
                                            var totalWorkingHours = 0;
                                            var totalBreakHours = 0;
                                            totalExpense += parseFloat(expensePopupDetail?.amount);
                                            tableColumns.push(
                                            		<tr>
    	                                            <td className="text-center">{index + 1}</td>
    	                                            <td className="">
    	                                            	{expensePopupDetail?.Saloon?.name}
    	                                            </td>
    	                                            <td className="">{expensePopupDetail?.purpose}</td>
    	                                            <td className="">
    	                                            {expensePopupDetail?.proof ? (
    	                                            		  <a
    	                                            		    href={`${uploadFolderUrl}/${expensePopupDetail.proof}`}
    	                                            		    target="_blank"
      	                                            			    rel="noopener noreferrer"
    	                                            		    data-fancybox="gallery"
    	                                            		    data-caption={`Proof for ${formatDate(new Date(expensePopupDetail.date))}`}
    	                                            		  >
    	                                            		    
    	                                            		    {formatDate(new Date(expensePopupDetail.date))}
    	                                            		  </a>
    	                                            		) : (
    	                                            		  formatDate(new Date(expensePopupDetail.date))
    	                                            		)}
    	                                            	
  	                                            			  
    	                                            </td>
    	                                            <td className="">{expensePopupDetail?.amount}</td>
    	                                        </tr>
                                            )
                                            return tableColumns;
                                        })()}
                                        </>
                                    ))
                                    tableColumns.push(
                                        <tr>
                                        	<td colSpan={3}></td>
                                            <td className="text-center" style={{'font-weight' : 'bold'}}>Total</td>
                                            <td className="" style={{'font-weight' : 'bold'}}>{totalExpense}</td>
                                         </tr>
                                    )
                                    return tableColumns;
                                
                        	 	})()}
                                {
                                    ( reports.length == 0 ) && ( <tr><td className="text-center" colSpan="10"><i class="bi bi-exclamation-circle"></i> No Data Found</td></tr> ) 
                                }
                        	</tbody>
                        </Table>
                      </ModalBody>
                      <ModalFooter>
                      <Button color="primary" onClick={() => setShowExpenseInfoModal(false)}>
                        Close
                      </Button>
                    </ModalFooter>
                    </Modal>
                  )}
        </React.Fragment>
    );
};

export default IncomeExpenseSummary;
